import axios from 'axios';
import intl from 'react-intl-universal';
import { store } from 'Store/store.index';
import { HttpRequest } from './request.utils';
import { baseUrlApis } from 'Api/index';
import { URL_CWS_API } from 'Api/constants';

export default class LMSApi extends HttpRequest {
  constructor() {
    super();
    this.lmsAxios = null;
    this.lmsDomain = '';
    this.init();
  }

  init() {
    try {
      baseUrlApis.getBaseUrlBy(URL_CWS_API).then(data => {
        this.lmsDomain = data+'/cpdfapi/v1/lms';
        this.paymentAxios = axios.create({
          baseURL: this.lmsDomain,
        });
        super.initialize(this.paymentAxios, () => {
          let responseCfg = {
            success: (res) => {
              return res.data;
            },
            error: (error) => {
              this.errorHandler(error);
              return Promise.reject(error);
            },
          };
          this.interceptorsProxyFn(null, responseCfg);
        });
      });
    } catch (e) {
      throw e;
    }

  }

  errorHandler(error) {
    let errorMsg;
    if (error.__CANCEL__) {
      errorMsg = intl.formatMessage({ id: 'CancelRequest' });
    } else {
      errorMsg = intl.formatMessage({ id: 'NetworkError' });
    }
    store.appStore.setGlobalMessage({ type: 'error', content: errorMsg });
  }

  // get platform data
  getDataFromPlatform({ token, key }) {
    return this.get({
      url: '/transfer-data',
      config: {
        params: {
          'access-token': token,
          key,
        },
      },
    });
  }

  // submint/unsubmit
  subAssignment(params) {
    const {
      token,
      type,
      lis_outcome_service_url,
      lis_result_sourcedid,
      oauth_consumer_key,
      oauth_signature_method,
      oauth_timestamp,
      oauth_nonce,
      oauth_version,
      ltiLaunchUrl,
    } = params;
    const formData = new FormData();
    formData.append('type', type);
    formData.append('lis_outcome_service_url', lis_outcome_service_url);
    formData.append('lis_result_sourcedid', lis_result_sourcedid);
    formData.append('oauth_consumer_key', oauth_consumer_key);
    formData.append('oauth_signature_method', oauth_signature_method);
    formData.append('oauth_timestamp', oauth_timestamp);
    formData.append('oauth_nonce', oauth_nonce);
    formData.append('oauth_version', oauth_version);
    if (Number(type) === 1) {
      formData.append('ltiLaunchUrl', ltiLaunchUrl);
    }
    return this.post({
      url: '/submit',
      config: {
        params: {
          'access-token': token,
        },
      },
      data: formData,
    });
  }

}
